import {
  Component,
  HostBinding,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter
} from "@angular/core";
import { QueueWithExt } from "../../../acdQueuesPage/acd-queues-page.component";
import { AddressSummaryService } from "@onsip/common/services/api/resources/addressSummary/address-summary.service";
import { map } from "rxjs";
import { FormatSingularAddressTypePipe } from "@onsip/web/features/shared/pipes/format-singular-address-type.pipe";

@Component({
  selector: "onsip-acd-queues-caller-view",
  templateUrl: "./acd-queues-caller-settings-view.component.html",
  styleUrls: ["../acdQueuesCallerSettingsEdit/acd-queues-caller-settings-edit.component.scss"],
  providers: [FormatSingularAddressTypePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AcdQueuesCallerViewComponent {
  @HostBinding("class.onsip-grid-content")
  @HostBinding("class.onsip-admin-host-grid")
  _dontUse = true;
  @Input() queue!: QueueWithExt;
  @Output() editPanel = new EventEmitter<void>();
  addresses = this.addressSummaryService.orgState;
  fullName$ = this.addresses.pipe(
    map(items => items.find(item => item.aor === this.queue.failoverAddress)),
    map(item =>
      item ? `(${this.singularAddressPipe.transform(item.addressType)}) ${item.name}` : "None"
    )
  );

  constructor(
    private addressSummaryService: AddressSummaryService,
    private singularAddressPipe: FormatSingularAddressTypePipe
  ) {}

  togglePanel(): void {
    this.editPanel.emit();
  }
}
